import contentTypes from "@/view/constants/contentTypes";

const getEventPropertiesContentType = (contentType) => {
  switch (contentType) {
    case contentTypes.ARTICLE:
      return "Article";
    case contentTypes.INTERACTIVE_VIDEO:
      return "interactivevideolink";
  }
};

export default getEventPropertiesContentType;
